// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3oxvD","title":"BackImages_title__2lwn8","images":"BackImages_images__3jBxv"};